// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5cb799c","239":"18b3cfe2","455":"d3d9f5e7"}[chunkId] + ".chunk.js";
};